import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { SettingsProvider } from "./context/SettingsContext";
import NotificationContainer from "./components/NotificationToast";
//import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter } from "react-router-dom";

// Validate environment variables
import env from "./config/env";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="/">
    <ThemeProvider>
      <AuthProvider>
        <SettingsProvider>
          <App />
          <NotificationContainer />
        </SettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);
//serviceWorkerRegistration.register();
